import { yupResolver } from "@hookform/resolvers/yup";
import {
  Button,
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
  Typography,
  Input,
} from "@material-tailwind/react";
import { addAdminValidation, adminValidationForm } from "./addAdminValidator";
import { useForm } from "react-hook-form";
import api from "../../../services/apiService";
import { useMutation } from "react-query";
import ApiRoutes from "../../../services/apiRoutes";
import { handleErrorMessage } from "../../../utility";
import ErrorParagraph from "../../../components/common/ErrorParagraph";
import DefaultLoading from "../../../components/common/DefaultLoading";
import ClickBaseButton from "../../../components/common/buttons/ClickBaseButton";
import { toast } from "react-toastify";

function AddRole({
  open: openDialog,
  handleOpen,
  getAdmins,
}: {
  open: boolean;
  handleOpen: () => void;
  getAdmins: () => void;
}) {
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm<adminValidationForm>({
    mode: "onChange",
    resolver: yupResolver(addAdminValidation),
  });
  const addAdminMutation = useMutation(
    (data: adminValidationForm) => api.post(ApiRoutes.createAdmin, data),
    {
      onSuccess: () => {
        handleOpen();
        toast.success("Admin added");
        getAdmins();
      },
      onError: (error) => {
        console.log(error);
        handleOpen();
        handleErrorMessage(error, "Unable add admin. Please try again later.");
      },
    }
  );
  const { isLoading } = addAdminMutation;

  const onSubmit = (data: adminValidationForm) => {
    console.log(data);
    addAdminMutation.mutate(data);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Dialog
        placeholder={undefined}
        open={openDialog}
        handler={handleOpen}
        size="md"
      >
        <DialogHeader placeholder={undefined} className="flex justify-center ">
          <Typography
            placeholder={undefined}
            className="font-medium text-xl mx-auto"
          >
            Add Admin
          </Typography>
        </DialogHeader>
        <hr />
        <DialogBody placeholder={undefined} className="!text-black px-10">
          <section className="my-4">
            <Typography placeholder={undefined}>First Name</Typography>
            <Input crossOrigin={undefined} {...register("firstName")} />
            {errors.firstName && (
              <ErrorParagraph message={errors.firstName.message!} />
            )}
          </section>
          <section className="my-4">
            <Typography placeholder={undefined}>Last Name</Typography>
            <Input crossOrigin={undefined} {...register("lastName")} />
            {errors.lastName && (
              <ErrorParagraph message={errors.lastName.message!} />
            )}
          </section>
          <section className="my-4">
            <Typography placeholder={undefined}>Email Address</Typography>
            <Input crossOrigin={undefined} {...register("email")} />
            {errors.email && <ErrorParagraph message={errors.email.message!} />}
          </section>
          <section className="my-4">
            <Typography placeholder={undefined}>Phone Number</Typography>
            <Input crossOrigin={undefined} {...register("phoneNo")} />
            {errors.phoneNo && (
              <ErrorParagraph message={errors.phoneNo.message!} />
            )}
          </section>
        </DialogBody>
        <DialogFooter placeholder={undefined}>
          {isLoading ? (
            <DefaultLoading />
          ) : (
            <section className="flex justify-center items-center mx-auto">
              <Button
                placeholder={undefined}
                variant="text"
                color="red"
                onClick={handleOpen}
                className="mr-1 text-lg font-light normal-case"
              >
                <span>Cancel</span>
              </Button>
              <div>
                <ClickBaseButton
                  onClick={handleSubmit(onSubmit)}
                  className="mt-0 text-lg px-10"
                >
                  Send
                </ClickBaseButton>
              </div>
            </section>
          )}
        </DialogFooter>
      </Dialog>
    </form>
  );
}

export default AddRole;
